const grid = {
  formulaBar: "שורת נוסחאות",
  bold: "מודגש",
  italic: "נטוי",
  cellColor: "צבע תא",
  textColor: "צבע טקסט",
  addColumn: "הוסף עמודה",
  removeColumn: "הסר עמודה",
  addRow: "הוסף שורה",
  removeRow: "הסר שורה",
  freezeColumn: "קפא עמודה",
  undo: "בטל",
  redo: "בצע שוב",
  exportCSV: "ייצוא CSV",
  addSheet: "הוסף גיליון",
  deleteSheet: "מחק גיליון",
  duplicateSheet: "שכפל גיליון",
} as const;
export default grid;
